<ng-container *ngIf="!big">
    <span class="loader" [class.disabled]="disabled" [class.disabled-no-bg]="disabledS"></span>
</ng-container>

<ng-container *ngIf="big">
    <div class="loader big" [class.no-bg]="noBg"></div>
</ng-container>